import { render, staticRenderFns } from "./RegisterFormView.vue?vue&type=template&id=2ae0cbe6&scoped=true&"
import script from "./RegisterFormView.vue?vue&type=script&lang=js&"
export * from "./RegisterFormView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormView.vue?vue&type=style&index=0&id=2ae0cbe6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0cbe6",
  null
  
)

export default component.exports